import React from "react";

export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <header className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-8 md:mb-10">
    <div className="fade-up min-w-0">
      {eyebrow && <p className="caption text-hearth-mute mb-2">{eyebrow}</p>}
      <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-hearth-ink leading-[1.05]">
        {title}
      </h1>
      {subtitle && <p className="text-hearth-mute mt-2 max-w-xl">{subtitle}</p>}
    </div>
    {action && <div className="flex flex-wrap items-center gap-2 lg:shrink-0">{action}</div>}
  </header>
);

export const EmptyState = ({ icon: Icon, title, message, action }) => (
  <div className="warm-card p-10 text-center fade-up">
    {Icon && (
      <div className="mx-auto w-14 h-14 rounded-full bg-hearth-terracotta/10 text-hearth-terracotta grid place-items-center mb-4">
        <Icon size={22} strokeWidth={1.6} />
      </div>
    )}
    <h3 className="font-display text-2xl font-semibold text-hearth-ink">{title}</h3>
    <p className="text-hearth-mute mt-2 max-w-md mx-auto">{message}</p>
    {action && <div className="mt-5">{action}</div>}
  </div>
);
